<template>
  <div class="col-xs-12 col-md-3 col-lg-4 text-center">
  <a class="btn btn-primary btn-lg" href="https://grotec.co.uk/contact">Contact Us <i
      class="fa fa-pencil-square"></i> </a>
  <h3>Contact</h3>

  <div class="vcard">
                                <span class="tel">
                                    <p>
                                        <strong>tel:</strong>
                                        <a class="hidden-md hidden-sm hidden-lg" href="tel:01706750293"
                                           title="01706 750 293">01706 750 293</a>
                                        <span class="hidden-xs" title="01706 750 293">01706 750 293</span>
                                    </p>
                                    <p>
                                        <strong>email</strong>
                                        <a href="mailto:info@grotec.co.uk"
                                           title="info@grotec.co.uk">info@grotec.co.uk</a>
                                    </p>
                                </span>
  </div>
  </div>
</template>
<script>
export default {
  name: 'contact-box'
}
</script>